import  React from 'react'
import { CardNumberField } from './CardNumberField'
import { TextField } from './TextField'
import { CvnField } from './CvnField'
import { IField, validateFields } from './FieldValidation'
/*import { CardDateField } from './CardDateField'

declare var __osfEwayKey: string
declare var eCrypt: any;

export interface CardFieldsProps {
    id: string
    cardNumberLabel?: string
    cardNameLabel?: string
    expiryDateLabel?: string
    cvnLabel?: string
}

export interface CardFieldsState {
    cardNumber?: string
    cardName?: string
    cvn?: string
    expiryMonth?: number
    expiryYear?: number
}

export interface CardDetails {
    name: string
    number: string
    expiryMonth: string
    expiryYear: string
    cvn: string
}

export class CardFields extends React.Component<CardFieldsProps, CardFieldsState> implements IField {
    cardNumber: CardNumberField
    cardName: TextField
    expiryDate: CardDateField
    cvn: CvnField

    constructor(props?: CardFieldsProps, context?: any) {
        super(props, context);

        this.state = {
            cardNumber: '',
            cardName: '',
            cvn: '',
            expiryMonth: 0,
            expiryYear: new Date().getFullYear()
        };
    }

    reset(callback?: () => any) {
        this.setState({
            cardNumber: '',
            cardName: '',
            cvn: '',
            expiryMonth: 0,
            expiryYear: new Date().getFullYear()
        }, callback);
    }

    focus() {
        this.cardNumber.focus();
    }

    validate(focus?: boolean) {
        var fields: IField[] = [this.cardNumber, this.cardName, this.expiryDate, this.cvn];
        let res = true;
        for (let f of fields) {
            let temp: boolean = f.validate(focus);
            if (!temp && res) {
                res = temp;
                focus = temp;
            }
        }
        return res;
    }

    setError(errorText?: string, callback?: { (): any }) {
        if (callback) {
            callback();
        }
    }

    getValue(): CardDetails {
        let expiryMonth = this.state.expiryMonth ? this.state.expiryMonth.toString() : "0";
        if (expiryMonth.length < 2) {
            expiryMonth = "0" + expiryMonth
        };

        let expiryYear = this.state.expiryYear ? this.state.expiryYear.toString() : "0000";
        expiryYear = expiryYear.substr(expiryYear.length - 2);

        return {
            number: eCrypt.encryptValue(this.state.cardNumber, __osfEwayKey),
            name: this.state.cardName,
            expiryMonth: expiryMonth,
            expiryYear: expiryYear,
            cvn: eCrypt.encryptValue(this.state.cvn, __osfEwayKey)
        };
    }

    render() {
        return <div>
            <CardNumberField
                id={`${this.props.id}_number`}
                ref={r => this.cardNumber = r}
                label={this.props.cardNumberLabel || "Card Number"}
                value={this.state.cardNumber}
                onChange={v => this.setState({ cardNumber: v })}
                required={true}
            />
            <TextField
                id={`${this.props.id}_name`}
                ref={r => this.cardName = r}
                label={this.props.cardNameLabel || "Card Name"}
                value={this.state.cardName}
                onChange={v => this.setState({ cardName: v })}
                required={true}
            />
            <CardDateField
                id={`${this.props.id}_date`}
                ref={r => this.expiryDate = r}
                label={this.props.expiryDateLabel || "Expiry Date"}
                monthValue={this.state.expiryMonth}
                yearValue={this.state.expiryYear}
                onMonthChage={v => this.setState({ expiryMonth: v })}
                onYearChage={v => this.setState({ expiryYear: v })}
                required={true}
            />
            <CvnField
                id={`${this.props.id}_cvn`}
                ref={r => this.cvn = r}
                label={this.props.cvnLabel || "CVV"}
                value={this.state.cvn}
                onChange={v => this.setState({ cvn: v })}
                required={true}
                help={<div>
                    <b><u>About Security Codes</u></b><br /><br />
                    Your Security Code is a number found on your card which helps to identify your card and protect you from fraud. It is also known as the CVV2, which stands for Card Verification Value 2, and often follows the last digits of your card number.<br /><br />
                    <b><u>Mastercard/Visa/Discover</u></b><br /><br />
                    <img src="img/cv2.jpg" /><br /><br />
                    <b><u>American Express</u></b><br /><br />
                    <img src="img/amexcvv.jpg" /><br /><br />
                </div>}
            />
        </div>
    }
}
*/